import { render, staticRenderFns } from "./SignUpVipBar.vue?vue&type=template&id=2c4630fe&scoped=true"
import script from "./SignUpVipBar.vue?vue&type=script&lang=js"
export * from "./SignUpVipBar.vue?vue&type=script&lang=js"
import style0 from "./SignUpVipBar.vue?vue&type=style&index=0&id=2c4630fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4630fe",
  null
  
)

export default component.exports